module.exports = __webpack_public_path__ + "img/image-eps.6bb270a6.png";